import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { taOptions } from 'textangular';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { HtmlService } from '../../../../../app.common/modules/common/services/html.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { WysiwygService } from '../../../../../app.common/modules/common/services/wysiwyg.service';
import { PreviousStateService } from '../../../../../app.common/modules/routes/previous-state.service';
import { BrandsService } from '../../../brands/brands.service';
import { CategoriesSelectorService } from '../../../categories/categoriesSelector.service';
import { IRetailerRootScope } from '../../../core/models';
import { NfcRetailerStickersService } from '../../../nfc-stickers/nfc-retailer-stickers.service';
import { InformationCardBaseController } from '../../informationCardBase.controller';
import { InformationCardsService } from '../../informationCards.service';

class InformationCardController extends InformationCardBaseController {
    static $inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'informationCardsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService', 'definitionsService',
        'wysiwygService', 'notificationService', '$translate', 'nfcRetailerStickersService'
    ];

    constructor(
        $rootScope: IRetailerRootScope,
        $scope: ng.IScope,
        $q: ng.IQService,
        $stateParams: StateParams,
        $timeout: ng.ITimeoutService,
        $previousState: PreviousStateService,
        informationCardsService: InformationCardsService,
        categoriesSelectorService: CategoriesSelectorService,
        brandsService: BrandsService,
        popupService: PopupService,
        taOptions: taOptions,
        htmlService: HtmlService,
        definitionsService: DefinitionsService,
        wysiwygService: WysiwygService,
        notificationService: NotificationService,
        $translate: angular.translate.ITranslateService,
        nfcRetailerStickersService: NfcRetailerStickersService
    ) {
        super($rootScope, $scope, $q, $stateParams, $timeout, $previousState, informationCardsService,
            categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService,
            wysiwygService, notificationService, $translate, nfcRetailerStickersService);

        this.model.loadedModel = this.loadedModel;
    }

    private loadedModel = () => {
        if (this.productForm) {
            this.$timeout(() => {
                this.productForm.$setPristine();
            });
        }
        $('.wrapUlTags.overflowY').slimScroll({
            height: '374px'
        });
        $('.textAreaCustScroll').slimScroll({
            height: '105px'
        });
    }
}
angular
    .module('naut').component('informationCard', {
        template: require('./informationCard.html'),
        controller: InformationCardController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/informationCards/components/informationCard/informationCard.component.ts